export default __webpack_public_path__ + "static/media/100_background.7c0d3b4e.gif";